export default __webpack_public_path__ + "static/media/0175.e467448a.jpg";